module.exports = __webpack_public_path__ + "img/usage-9.672cc294.png";